
import React from 'react';
import resetPasswordPage from '../pages/reset-password/reset-password.page';
import IRoute from './layout.state';

const HomePage = React.lazy(() => import('../pages/home/home.page'));
const AgentPage = React.lazy(() => import('../pages/agent/agent.page'));
const PassengerPage = React.lazy(() => import('../pages/passenger/passenger.page'));
const ReportsPage = React.lazy(() => import('../pages/reports/reports.page'));
const InvoicesPage = React.lazy(() => import('../pages/invoices/invoices.page'));
const BookingCreatePage = React.lazy(() => import('../pages/booking/booking-create.page'));
const BookingListPage = React.lazy(() => import('../pages/booking/booking-list.page'));
const DriverLocationPage = React.lazy(() => import('../pages/driver-location/driver-location.page'));

export const privateRoutes: IRoute[] = [
  { path: '/agent', component: AgentPage, showLogin: true },
  { path: '/passenger', component: PassengerPage, showLogin: true },
  { path: '/invoices', component: InvoicesPage, showLogin: true },
  { path: '/reports', component: ReportsPage, showLogin: true },
  { path: '/booking-create', component: BookingCreatePage, showLogin: true },
  { path: '/booking-list', component: BookingListPage, showLogin: true },
  { path: '/driver-location', component: DriverLocationPage, showLogin: true }
]

export const routes: IRoute[] = [
  { path: '/', component: HomePage },
  { path: '/set-password', component: resetPasswordPage },
];

export default routes;
